import React, { useEffect, useRef, useState } from "react";
import settingIcon01 from "../../images/setting_icon_01.png";
import resetIcon01 from "../../images/reset_icon_01.png";
import searchIcon01 from "../../images/search_icon_01.png";
import addIcon01 from "../../images/add_icon_01.png";
import { Link } from "react-router-dom";
import { useAppContext } from "../../utils/store";
import {
  getStatusClassName,
  getStatusColorClassName,
  getStatusName,
  getUserAuthorityName,
} from "../../utils/common";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { API_HOST } from "../../Constants";
import MainHeader from "../MainHeader";
import MainMenu from "../MainMenu";
import { connectRealtimeFireStatusWebSocket } from "../../websock/realtimeFireStatusManager";

export default function FireOnListComponent() {
  const {
    store: { id },
  } = useAppContext();
  const [listItemWrapHeight, setListItemWrapHeight] = useState(0);
  const fireItemListRef = useRef(null);
  const listItemWrapRef = useRef(null);
  const searchTextRef = useRef(null);
  const [dataSource, setDataSource] = useState([]);
  const [lastFilterValue, setLastFilterValue] = useState("");
  const [checkedItem, setCheckedItem] = useState(null);
  const [isShowSearch, setIsShowSearch] = useState(false);

  useEffect(() => {
    connectRealtimeFireStatusWebSocket(id, (data) => {
      const runStatusList = data.runStatusList;

      setDataSource((prevData) =>
        prevData.map((item) => {
          if (runStatusList[item.id] !== undefined) {
            return { ...item, status: runStatusList[item.id] };
          }
          return item;
        })
      );
    });

    const updateListItemHeight = () => {
      const fireItemList = fireItemListRef.current;
      const listItemWrap = listItemWrapRef.current;

      if (fireItemList && listItemWrap) {
        const fireItemListHeight = fireItemList.clientHeight;
        const listItemWrapHeight = fireItemListHeight;

        setListItemWrapHeight(listItemWrapHeight);
      }
    };

    // 창 크기 변경 시, 페이지 로드 시, DOM 변화 감지 시 높이 업데이트
    window.addEventListener("resize", updateListItemHeight);
    window.addEventListener("load", updateListItemHeight);

    const observer = new MutationObserver(updateListItemHeight);
    observer.observe(document.body, { childList: true, subtree: true });

    getData("");

    // cleanup (컴포넌트 언마운트 시)
    return () => {
      window.removeEventListener("resize", updateListItemHeight);
      window.removeEventListener("load", updateListItemHeight);
      observer.disconnect();
    };
  }, []);

  const getData = (filterValue) => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireFightingObjectList(
        "2", //건물명으로 검색
        filterValue
      );
      if (status === true) {
        setDataSource(data);

        if (data.length === 0) {
          alert(`조회 결과가 없습니다.`);
        }
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleReload = (event, filterValue) => {
    if (event) {
      const button = event.currentTarget;
      const img = button.querySelector("img");
      img.classList.remove("img-rotate");
      void img.offsetWidth;
      img.classList.add("img-rotate");
    }

    if (lastFilterValue === null) {
      filterValue = lastFilterValue;
    }

    getData(filterValue);

    setLastFilterValue(filterValue);
    setCheckedItem(null);
  };

  const handleChangeCheck = (item) => {
    setCheckedItem(item);
  };

  const handleChangeSearchText = (e) => {
    if (e.keyCode === 13) {
      handleSearch();
    }
  };

  const handleSearch = (e) => {
    if (e.keyCode === 13) {
      if (searchTextRef.current.value === "") {
        handleReload(null, "");
      } else {
        handleReload(null, searchTextRef.current.value);
      }
    }
  };

  return (
    <section class="mbSection mainSection">
      <div class="black-box">
        <MainHeader isOpenMenu={false} isShowTopPanel={true} isShowNotice={true} />
      </div>

      <div ref={fireItemListRef} class="fireItemList">
        <div class="listStatusWrap">
          <div class="list-top-wrap">
            <div class="list-total-wrap">
              <p class="total-title">소방대상물</p>
              <span class="divi"></span>
              <p class="total-num">전체 {dataSource.length}개소</p>
            </div>
            <div class="list-set-wrap">
              <button
                class="btn btn-reset"
                onClick={(e) => {
                  handleReload(e, null);
                }}
              >
                <img src={resetIcon01} alt="초기화" />
                초기화
              </button>
              <span class="divi"></span>
              <Link class="set-title" to="/fire-on/edit/">
                편집
              </Link>
            </div>
          </div>
          {isShowSearch === false ? (
            <div class="list-control-wrap" style={{ display: "flex" }}>
              <div class="list-action-wrap">
                <button
                  class="btn btn-search"
                  onClick={() => setIsShowSearch(true)}
                >
                  <img src={searchIcon01} alt="검색" />
                </button>
                <Link class="btn btn-add" to="/fire-on/add/">
                  <img src={addIcon01} alt="추가" />
                </Link>
              </div>
              {/* <div class="list-filter-wrap">
              <button class="btn btn-filter">
                <img src={filterIcon01} alt="필터" />
                화재 경보
              </button>
            </div> */}
            </div>
          ) : (
            <div class="item-search-wrap" style={{ display: "flex" }}>
              <input
                ref={searchTextRef}
                type="text"
                class="searchInput"
                placeholder="등록된 소방대상물을 검색해보세요."
                onChange={handleChangeSearchText}
                onKeyDown={handleSearch}
              />
              <button class="btn-cancle" onClick={() => setIsShowSearch(false)}>
                취소
              </button>
            </div>
          )}
        </div>
        <div
          ref={listItemWrapRef}
          class="list-item-wrap"
          style={{
            maxHeight: `${listItemWrapHeight}px`,
            minHeight: `${listItemWrapHeight}px`,
          }}
        >
          {dataSource &&
            dataSource.length > 0 &&
            dataSource.map((item, index) => (
              <div
                className={`list-item ${getStatusClassName(item.status)} ${item === checkedItem ? "active" : ""
                  }`}
                onClick={() => handleChangeCheck(item)}
              >
                <div class="item-cont-wrap">
                  <div class="item-detail-wrap">
                    <div class="item-img-wrap">
                      <img src={API_HOST + item.buildingPhoto} alt="" />
                    </div>
                    <div class="item-info-wrap">
                      <p class="info-title">{item.buildingName}</p>
                      <p class="info-adr">
                        {`${item.roadAddress} ${item.roadAddressDetail}`}
                      </p>
                    </div>
                  </div>
                  <div class="wrap_state_item">
                    <div className={`cir_state ${getStatusColorClassName(item.status)}`}></div>
                    <p class="title_state">{getStatusName(item.status)}</p>
                  </div>
                </div>
                <div class="item-btn-wrap">
                  <Link
                    class="btn btn-overview"
                    to={`/fire-on/boundary-map/${item.id}/`}
                    state={{
                      buildingName: item.buildingName,
                    }}
                  >
                    경계구역 일람도
                  </Link>
                  <Link
                    class="btn btn-dashboard"
                    to={`/fire-on/fire-alarm-monitor/${item.id}/`}
                    state={{
                      buildingName: item.buildingName,
                    }}
                  >
                    대시보드
                  </Link>
                </div>
              </div>
            ))}
        </div>
      </div>

      {checkedItem && (
        <div className="floating-btn-wrap" style={{ display: "flex" }}>
          <Link class="floatingLink" to={`/fire-on/fire-alarm-setting/sms/`}>
            SMS설정
          </Link>
          <Link class="floatingLink" to={`/fire-on/fire-alarm-setting/`}>
            경보음 설정
          </Link>
          <Link class="floatingLink" to={`/fire-on/fire-inspection-schedule/${checkedItem.id}`} state={{ firefightingObject: checkedItem }}>
            점검일정
          </Link>
        </div>
      )}

      <MainMenu />
    </section>
  );
}
